import { SvgEnSavoir } from "./svg"

type LinkButtonProps = {
  onClick?: any,
  title: string,
  icon?: React.ReactNode,
  gap?: number,
}

export const LinkButton = (props: LinkButtonProps) => {

  return (
    <a
      href="#"
      data-type="group"
      data-width="auto"
      data-gap={props.gap || 5}
      data-interactive="highlight"
      onClick={props.onClick}
    >
      <icon data-svg-color="secondary" data-color="secondary" data-size="20" data-svg-size="20">
        {props.icon ? props.icon : <SvgEnSavoir />}
      </icon>
      <text data-text-size="medium" data-ellipsis="" data-color="secondary">
        {props.title}
      </text>
    </a>
  )
}